<template>
  <div>
    <vs-card id="automatic-expense-table-loading" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vendor-list
            :data="data"
            @search="search"
            @loadMore="loadMore"
            @refresh="search"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import request from './request'
import loading from '@/mixins/Loading'
import VendorList from './components/VendorList.vue'
import vSelect from 'vue-select'

export default {
  components: {
    VendorList,
    vSelect,
  },
  data() {
    return {
      data: [],
      vendorList:[],
      params: {
        lastPage: 1,
        page: 1,
        search: ''
      },
    }
  },
  mixins: [loading],
  methods: {
    getData() {
      this.openLoading('automatic-expense-table-loading')
      let payload = { ...this.params }
      request
        .list(payload)
        .then((response) => {
          this.params.lastPage = response.data.vendors.last_page
          this.params.page = response.data.vendors.current_page
          let data = response.data.vendors.data
          data.map((obj) => {
            obj.active = obj.active === '1' ? true : false
            return obj
          })
          if (this.params.page === 1) {
            this.data = [...data]
          } else {
            this.data = [...this.data, ...data]
          }
          this.closeLoading('automatic-expense-table-loading')
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading('automatic-expense-table-loading')
        })
    },
    loadMore() {
      if (this.params.page >= this.params.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search(event = '') {
      this.params.search = event
      this.params.page = 1
      this.getData()
    }
  },
  mounted() {
    this.getData()
    
  },
}
</script>

<style>
</style>